import React, {Component} from "react";

export default function SalaryFork({data}){
    return ( <div className="vacancy-salary">
            {data ? <span  dangerouslySetInnerHTML={{__html: data}} /> : null}
        </div>
    )
}